import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { BUDGET_LINE_ITEMS } from "./apiRoutes";

const mutateAddMonthlyDistribution = async ({
  lineItemId,
  budgetId,
  data,
}: {
  lineItemId: string;
  budgetId: string;
  data: FieldValues;
}) => {
  return await axiosAuth.post(
    `${BUDGET_LINE_ITEMS(budgetId)}/${lineItemId}/monthly-distribution`,
    data
  );
};

const useAddMonthlyDistributionMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      lineItemId: string;
      budgetId: string;
      data: FieldValues;
    },
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateAddMonthlyDistribution,
    ...queryParams,
  });

export default useAddMonthlyDistributionMutation;
